import React from 'react';
import { useScrollPosition } from '../../hooks/useScrollPosition';

export const Hero = ({ loaded }) => {
  const scrollY = useScrollPosition();
  return (
    <section className={`hero ${loaded ? 'loaded' : ''}`} id="hero">
      <div className="hero-bg">
        <img className="hero-bg-image" src="/e32181f0-cadd-49f9-add0-2e59f87e40e2.jpg" alt="" style={{ transform: `scale(1) translateY(${scrollY * 0.3}px)` }} />
      </div>
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-subtitle">Архив филиала МАУ в городе Кировске</div>
        <h1 className="hero-title">
          <span className="line"><span>Время,</span></span>
          <span className="line"><span>запечатлённое</span></span>
          <span className="line"><span>в серебре</span></span>
        </h1>
        <p className="hero-description">Коллекция старинных фотографий, сохранённых от забвения. Каждое фото — окно в ушедшую эпоху.</p>
        <div className="hero-scroll" onClick={() => document.getElementById('timeline').scrollIntoView({ behavior: 'smooth' })}>
          <span>Листать</span>
          <div className="hero-scroll-line" />
        </div>
      </div>
    </section>
  );
};